// apps/client/src/ui/screens/storage.tsx (M1-T13) — your house storage, opened from Pockets inside your own house: the 20 pocket
// slots beside the storage slots (8 columns, scrolling). Tapping an item sends it to the other side. Closes when you leave home.
import { tuning } from '@whiskerton/content';
import type { ItemView } from '@whiskerton/shared';
import { useEffect } from 'react';
import { useShallow } from 'zustand/react/shallow';
import { useCommands } from '../../game/instance';
import { useGame } from '../../state/store';
import { useT } from '../i18n';
import { SlotGrid } from '../items/SlotGrid';
import { Panel } from '../kit';
import type { ScreenDef } from '../router';

declare module '../router' { interface ScreenParams { storage: undefined } }

function Storage({ close }: { close: () => void }) {
  const t = useT();
  const cmd = useCommands();
  const { you, space } = useGame(useShallow((s) => ({ you: s.you, space: s.space })));
  const atHome = !!you && space.startsWith(`house:${you.resident}:`);
  useEffect(() => { if (!atHome) close(); }, [atHome, close]);
  const items = you?.items ?? [];
  const send = (to: 'pockets' | 'storage') => (i: ItemView | undefined) => { if (i) void cmd.moveItem(i.id, to, null); };
  return (
    <Panel title={t('items.storage')} className="storage-panel">
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1.55fr', gap: '2.4cqw', width: '78cqw', maxWidth: '100%' }}>
        <section aria-label={t('items.pockets')}>
          <h3 style={{ marginTop: 0 }}>{t('items.pockets')}</h3>
          <SlotGrid items={items.filter((i) => i.at.loc === 'pockets')} slots={tuning.items.pocketSlots} columns={5} selected={null} onPick={send('storage')} />
        </section>
        <section aria-label={t('items.storage')}>
          <h3 style={{ marginTop: 0 }}>{t('items.storage')}</h3>
          <div style={{ maxHeight: '58cqh', overflowY: 'auto' }}>
            <SlotGrid items={items.filter((i) => i.at.loc === 'storage')} slots={tuning.items.storageSlots} columns={8} selected={null} onPick={send('pockets')} />
          </div>
        </section>
      </div>
    </Panel>
  );
}
export const screen: ScreenDef<'storage'> = { id: 'storage', layer: 'panel', component: ({ close }) => <Storage close={close} /> };
